export default "__VITE_ASSET__frjTcapI__"